var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.308 22.5c-.505 0-.933-.175-1.283-.525a1.745 1.745 0 01-.525-1.283V3.308c0-.505.175-.933.525-1.283.35-.35.778-.525 1.283-.525h9.384c.505 0 .933.175 1.283.525.35.35.525.778.525 1.283v17.384c0 .505-.175.933-.525 1.283-.35.35-.778.525-1.283.525H7.308zM7 19.75v.942c0 .077.032.148.096.212a.294.294 0 00.212.096h9.384a.294.294 0 00.212-.096.294.294 0 00.096-.212v-.942H7zm0-1.5h10V5.75H7v12.5zm0-14h10v-.942a.294.294 0 00-.096-.212.294.294 0 00-.212-.096H7.308a.294.294 0 00-.212.096.294.294 0 00-.096.212v.942z",
    fill: "currentColor"
  })));
}
SvgPhone.displayName = 'Phone';
export default SvgPhone;